// Citirex case studies — placeholder content
export const CASE_STUDIES = [
  {
    slug: "national-pc-carrier-auto-bind-rate",
    vertical: "Auto Insurance",
    partner: "Top-25 National P&C Carrier",
    title: "Doubling auto bind rate against three legacy lead vendors",
    summary:
      "How a refined appetite filter and live-transfer rebuild lifted bind rate from 4.1% to 9.4% in two quarters.",
    metrics: [
      { v: "+128%", l: "Bind rate vs. control" },
      { v: "-37%", l: "CPA vs. prior vendor mix" },
      { v: "2 quarters", l: "Time to scale" },
    ],
    cover: "https://images.pexels.com/photos/3422964/pexels-photo-3422964.jpeg",
    sections: [
      {
        h: "The brief",
        p: "The carrier's growth team had a national appetite, but three legacy vendors were delivering volume against the wrong risk profile — driving down quote-to-bind and inflating CPA.",
      },
      {
        h: "What we built",
        p: "We rebuilt the qualification flow against their appetite document: state-level age bands, vehicle counts, SR-22 knockouts, and a homeowner cross-flag for bundling intent. Hot transfers were routed to their highest-LTV territories first.",
      },
      {
        h: "The result",
        p: "Bind rate moved from 4.1% to 9.4% in two quarters. CPA dropped 37% on like-for-like cohorts. Citirex absorbed 100% of their new-business spend within twelve months.",
      },
    ],
  },
  {
    slug: "medicare-fmo-t65-pipeline",
    vertical: "Medicare",
    partner: "National Medicare Advantage FMO",
    title: "Building a year-round T65 pipeline outside of AEP",
    summary:
      "How CMS-compliant T65 birthday triggers replaced two field marketing organizations.",
    metrics: [
      { v: "8 mo.", l: "Pre-eligibility lead time" },
      { v: "+42%", l: "OEP lift YoY" },
      { v: "98%", l: "SOA audit pass rate" },
    ],
    cover:
      "https://images.unsplash.com/photo-1514415008039-efa173293080",
    sections: [
      {
        h: "The brief",
        p: "An MA FMO needed a year-round T65 pipeline that wouldn't collapse outside of AEP — and that would survive a CMS audit on day one.",
      },
      {
        h: "What we built",
        p: "PTC-compliant creative reviewed against CMS Ch. 3, paired with birthday-trigger campaigns running 8 months out from eligibility. Every lead carried SOA-ready consent and a full audit trail.",
      },
      {
        h: "The result",
        p: "T65 enrollments rose 42% YoY in OEP, with a 98% SOA audit pass rate. The FMO retired two field marketing organizations within the first contract year.",
      },
    ],
  },
  {
    slug: "top-10-solar-installer-appointment-set",
    vertical: "Solar",
    partner: "Top-10 National Solar Installer",
    title: "Setters that close: rebuilding the solar qualifier",
    summary:
      "How a utility-bill-driven calculator cut tire-kicker volume by 61% and lifted close rate by a third.",
    metrics: [
      { v: "-61%", l: "Tire-kicker volume" },
      { v: "+34%", l: "Close rate" },
      { v: "$2.7M", l: "Incremental ARR" },
    ],
    cover:
      "https://images.pexels.com/photos/35726122/pexels-photo-35726122.jpeg",
    sections: [
      {
        h: "The brief",
        p: "A top-10 installer was burning setter capacity on prospects who didn't own their home, didn't have qualifying roof, or didn't pay enough utility to justify a system.",
      },
      {
        h: "What we built",
        p: "We rebuilt the qualifier around utility-bill capture, soft-pull credit signaling, and roof/shading screens — all before submission. Compliant TCPA capture with per-lead consent recordings.",
      },
      {
        h: "The result",
        p: "Tire-kicker volume dropped 61%. Close rate lifted 34% with the same headcount. Incremental ARR contribution in year one was $2.7M.",
      },
    ],
  },
  {
    slug: "regional-roofing-contractor-appt-set",
    vertical: "Home Services",
    partner: "Regional Roofing & Exterior Contractor",
    title: "Booking project-ready homeowners by ZIP",
    summary:
      "How geo-fenced creative and appointment-set delivery filled four crews without growing headcount.",
    metrics: [
      { v: "70%", l: "Booked-appt rate" },
      { v: "<2 mi.", l: "Avg. crew-to-lead" },
      { v: "4 crews", l: "Filled, no new HC" },
    ],
    cover:
      "https://images.pexels.com/photos/16631149/pexels-photo-16631149.jpeg",
    sections: [
      {
        h: "The brief",
        p: "A regional roofer had four crews idling between storm cycles and no consistent way to fill the calendar in non-event months.",
      },
      {
        h: "What we built",
        p: "ZIP-level geo-fenced creative, project-type qualifiers, and appointment-set delivery routed to the nearest crew — all under 2 miles average crew-to-lead distance.",
      },
      {
        h: "The result",
        p: "Booked-appointment rate hit 70%. Four crews fully booked across the off-season without growing field headcount. Customer LTV up 22%.",
      },
    ],
  },
];

export const CASE_STUDY_BY_SLUG = Object.fromEntries(
  CASE_STUDIES.map((c) => [c.slug, c]),
);
